'use strict';
import React, { PureComponent } from 'react';
import GrupoRadioButton from './Common/GrupoRadioButton';

class SeccionSuperior extends PureComponent {
    constructor(props) {
        super(props);
        this.validarEjecucionProceso = this.validarEjecucionProceso.bind(this);
        this.cambiarOpcion = this.cambiarOpcion.bind(this);
        this.ocultarMostrarOpciones = this.ocultarMostrarOpciones.bind(this);
        this.cambiarValorRB = this.cambiarValorRB.bind(this);

        this.state = {
            //Objeto que guarda toda la información necesaria para el botón de Ejecución del Contabilizador/Re-contabilizador
            botonEjecutar: {
                mostrarOpciones: false,                         //Flag que determina si se muestran las opciones posibles a elegir para el botón principal
                actualizacionDefaultHecha: false,               //Flag utilizado para determinar si se debe de actualizar el state cuando se selecciona la opción del radiobutton de "Contabilizador"
                esContabilizador: true,                         //Flag que determina si la opción escogida actualmente es del Contabilizador (true: Contabilizador / false: Re-contabilizador)
                esFechaContabilizacionIgualFechaActual: false,  //Flag que determina si la fecha de contabilización obtenida es igual a la fecha actual. Este valor solo es tenido en cuenta cuando se seleccionó la opción de "Contabilizador"
                opcionSeleccionada: 0,                          //Id de la opción elegida
                opciones: [                                     //Array que contiene las dos opciones posibles para elegir como botón
                    {Id: 0, Descripcion: "Ejecutar Lote"},
                    {Id: 1, Descripcion: "Ejecutar Contabilidad del Día"}
                ]
            }
        }
    }

    cambiarValorRB(nombre, valor) {
        //Se reinician los valores por default
        this.setState((prevState) => ({
            botonEjecutar: {
                ...prevState.botonEjecutar,
                esContabilizador: valor == 0,
                opcionSeleccionada: 0,
                actualizacionDefaultHecha: false,
                esFechaContabilizacionIgualFechaActual: false
            }
        }));

        this.props.seleccionarRadioButtonContabilizador(nombre, valor);
    }

    cambiarOpcion(opcionSeleccionada) {
        this.setState((prevState) => ({
            botonEjecutar: {
                ...prevState.botonEjecutar,
                mostrarOpciones: false,
                opcionSeleccionada
            }
        }));
    }

    ocultarMostrarOpciones(mostrarOpciones) {
        this.setState((prevState) => ({
            botonEjecutar: {
                ...prevState.botonEjecutar,
                mostrarOpciones
            }
        }));
    }

    componentDidUpdate() {
        //Se hace uso de "componentDidUpdate" para determinar en cada renderizado si se debe cambiar el comportamiento del botón para la opción del "Contabilizador" según las siguientes condiciones:
            //Si se ejecutaron la totalidad de los procesos (barra de avance = 100%) entonces el botón debe mostrar por defecto la opción de "Ejecutar Contabilidad del Día"
            //Si la fecha de ejecución de la Contabilidad se corresponde con la fecha actual, se dejerá por defecto la opción de "Ejecutar Lote". Asimismo, dentro del método render() se ocultará la posibilidad de seleccionar la opción de "Ejecutar Contabilidad del Día"
        
        //Si se realizó la actualización del state desde aquí, se actualiza el flag "actualizacionDefaultHecha" para que, en el caso de seleccionar la opción de "Re-Contabilización" no se realice la actualización del state por acá
        if(!this.state.botonEjecutar.actualizacionDefaultHecha && this.state.botonEjecutar.esContabilizador) {
            const barraAvance = this.props.data.barraAvance && this.props.data.barraAvance.length > 0 && this.props.data.barraAvance[0];
            const esFechaContabilizacionIgualFechaActual = barraAvance && 
                                                           new Date(barraAvance.FechaEjecucion).toLocaleDateString('en-GB') == new Date().toLocaleDateString('en-GB');

            if(barraAvance.FechaContabilidadOriginal == null) {
                let opcionSeleccionada = this.props.seEjecutoTotalidadProcesos ? 1 : 0;
                opcionSeleccionada = esFechaContabilizacionIgualFechaActual ? 0 : opcionSeleccionada;

                this.setState((prevState) => ({
                    botonEjecutar: {
                        ...prevState.botonEjecutar,
                        opcionSeleccionada,
                        actualizacionDefaultHecha: true,
                        esFechaContabilizacionIgualFechaActual
                    }
                }));
            }
        }
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    validarEjecucionProceso(nombreProceso, tipoEjecucion) {
        this.props.validarEjecucionProceso(nombreProceso,true, tipoEjecucion);
    }

    refrescarDatosPantalla(){
        this.props.refrescarDatosPantalla();
    }

    render() {
        const {
            data
        } = this.props;

        const { 
            botonEjecutar 
        } = this.state;

        const valorRBContabilizacion = data.radioButtonsContabilizador?.contabilizacion;
        const inhabilitarBotonDesplegable = (botonEjecutar.esContabilizador && botonEjecutar.esFechaContabilizacionIgualFechaActual) || data.hayProcesosEnEjecucion || !botonEjecutar.esContabilizador;

        return (
            <div>
                <div className="seccionSuperior__titulo">Contabilización | Re-contabilización</div>
                <div className="ContabilizadorRecontabilizador__seccionSuperior">
                    <div className="seccionDatosGenerales__tituloSecundario">Acción a ejecutar</div>
                    <div className="AsientosContables--overflowHidden">
                        <div className="AsientosContables--overflowHidden AsientosContables--floatLeft ContabilizadorRecontabilizador__contenedorRB">
                            <div className="AsientosContables--floatLeft">
                                <GrupoRadioButton 
                                    label={"Contabilización"}
                                    nombre={"contabilizacion"}
                                    valor={0}
                                    activo={valorRBContabilizacion == 0}
                                    onClick={this.cambiarValorRB}
                                />
                            </div>

                            <div className="AsientosContables--floatLeft ContabilizadorRecontabilizador__RBDerecho">
                                <GrupoRadioButton 
                                    label={"Re-contabilización"}
                                    nombre={"contabilizacion"}
                                    valor={1}
                                    activo={valorRBContabilizacion == 1}
                                    onClick={this.cambiarValorRB}
                                />
                            </div>
                        </div>
                        
                        <div className="AsientosContables--floatRight">
                            <div className={"ContabilizadorRecontabilizador__contenedorBotonEjecutar botonesContabilizador"}>
                                <button className={"seccionCabecera__botonAceptar" + (data.habilitarEjecucionReconta && !data.hayProcesosEnEjecucion ? "" : " ContabilizadorRecontabilizador__botonDeshabilitado")} onClick={data.habilitarEjecucionReconta && !data.hayProcesosEnEjecucion ? () => this.validarEjecucionProceso(data.nombreProceso, this.state.botonEjecutar.opcionSeleccionada) : null}>
                                    {botonEjecutar.opciones.find(opcion => opcion.Id == botonEjecutar.opcionSeleccionada).Descripcion}
                                </button>

                                <div className="separadorBotones"></div>

                                <button className={"seccionCabecera__botonAceptar" + (inhabilitarBotonDesplegable ? " ContabilizadorRecontabilizador__botonDeshabilitado" : "")} onClick={inhabilitarBotonDesplegable ? null : () => this.ocultarMostrarOpciones(!botonEjecutar.mostrarOpciones)}>
                                    <div className="iconFeclaDesplegable"></div>
                                </button>
                            </div>

                            {botonEjecutar.mostrarOpciones &&
                                <div className="ABMModelos__ContenedorOpcionesBuscadorImportarModelos ContabilizadorRecontabilizador__opcionesDesplegables">
                                    {botonEjecutar.opciones.map(opcion => {
                                        return <div key={opcion.Id} className="ABMModelos__opcionBuscadorCuentasContables ContabilizadorRecontabilizador__opcionBotonEjecutar" onClick={() => this.cambiarOpcion(opcion.Id)}>{opcion.Descripcion}</div>
                                    })}
                                </div>
                            }
                        </div>

                        <div data-toggle="tooltip" data-title="Refrescar el estado de la ejecución" data-placement="left" data-original-title="" className="icon-container-refresco ">
                            <div className="image-refrescar-icono" onClick={() => this.refrescarDatosPantalla()}></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SeccionSuperior;